import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from '../../theme';
import { getThemeBottomBarHeight } from '../BottomBar';
import TopBarComponent from '../TopBar';
import Spacer from '../Spacer';
import topBarLinkShape from '../../shapes/topBarLink';
import WellIcon from './WellIcon';
import WHSIcon from './WHSIcon';

const Container = styled.div`
  margin: 0px auto ${getThemeBottomBarHeight};
  max-width: ${theme('layout.pageWidth')};
  width: 100%;
  padding: 0 ${theme('spacing.regular')};
  height: auto;
  position: relative;
  box-sizing: border-box;
  z-index: 1;
`;

const PageBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 0;
  background: ${({ dark, maintenanceBg, theme: t }) =>
    maintenanceBg
      ? `url(/backgrounds/maintenance.png) ${t.colors.backgroundDark} 50% / cover no-repeat`
      : dark
      ? t.colors.backgroundDark
      : t.colors.backgroundLight};
  opacity: ${({ maintenanceBg }) => (maintenanceBg ? '0.2' : '1')};
`;

const PageContainer = ({
  children = [],
  form,
  formMultipart,
  formAction,
  formOnSubmit,
  topBarLinks,
  hideMobileMenu,
  dark,
  pharmacy,
  maintenanceBg,
}) => (
  <Fragment>
    <TopBarComponent
      links={topBarLinks}
      hideMobileMenu={hideMobileMenu}
      icon={pharmacy === 'wardles' ? <WHSIcon /> : <WellIcon />}
    />
    <Container>
      {form || formMultipart ? (
        <form
          method="POST"
          id="page-form"
          action={formAction}
          onSubmit={formOnSubmit}
          encType={
            formMultipart
              ? 'multipart/form-data'
              : 'application/x-www-form-urlencoded'
          }
        >
          {children}
        </form>
      ) : (
        children
      )}
      <Spacer size="huge" />
    </Container>
    <PageBackground dark={dark} maintenanceBg={maintenanceBg} />
  </Fragment>
);

PageContainer.propTypes = {
  children: PropTypes.any.isRequired,
  form: PropTypes.bool,
  formMultipart: PropTypes.bool,
  formAction: PropTypes.string,
  formOnSubmit: PropTypes.func,
  dark: PropTypes.bool,
  topBarLinks: PropTypes.arrayOf(topBarLinkShape),
  hideMobileMenu: PropTypes.bool,
  pharmacy: PropTypes.string,
  maintenanceBg: PropTypes.bool,
};

PageContainer.defaultProps = {
  form: false,
  formMultipart: false,
  formAction: undefined,
  formOnSubmit: undefined,
  dark: false,
  topBarLinks: [],
  hideMobileMenu: false,
  pharmacy: '',
  maintenanceBg: false,
};

export default PageContainer;
